import React from 'react';
import { Translate } from 'react-redux-i18n';
import { isOLG, isVAK, isSH, isAP, isGFD } from '../../actions/root_url';

const TypeRadios = React.createClass({
  render() {
    return (
      <div className="form-group" id="search-product-by">
        <label className="col-xs-1" style={{width: '55px', paddingRight: '0px'}}>
          <Translate value="search" />:
        </label>
        {
          this.props.InvoiceNoSearch && (
            <label className="col-xs-2" style={{width: '60px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="invoiceNo"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'invoiceNo'}
              />
              <Translate value={this.props.isQuote ? "SQ_no" : "SO_no"} />
            </label>
          )
        }
        {
          this.props.SalesOrderNoSearch && (
            <label className="col-xs-2" style={{width: '70px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="order_num"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'order_num'}
              />
              <Translate value="po_no" />
            </label>
          )
        }
         {
          this.props.POSNumSearch && (
            <label className="col-xs-2" style={{width: '70px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="pos_num"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'pos_num'}
              />
              <Translate value="pos_no" />
            </label>
          )
        }
        {
          this.props.BillOfLadingSearch && (
            <label className="col-xs-2" style={{width: '60px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="boln"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'boln'}
              />
              <Translate value="bol_no" />
            </label>
          )
        }
        {
          this.props.TrackingNoSearch && (
            <label className="col-xs-2" style={{width: '78px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="trackingNo"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'trackingNo'}
              />
              <Translate value="track_no" />
            </label>
          )
        }
        {
          this.props.groupSearch && (
            <label className="col-xs-2" style={{width: '70px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="Group"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'Group'}
              />
              <Translate value="group" />
            </label>
          )
        }
        {
          this.props.customerSearch && (
            <label className="col-xs-2" style={{width: '78px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="CustName"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'CustName'}
              />
              <Translate value="customer" />
            </label>
          )
        }
        {!(isOLG || isSH || isAP) && <label className="col-xs-2" style={{width: '75px', paddingRight: '0px'}}>
          <input
            style={{marginRight: '3px'}}
            type="radio"
            value="ProductNum"
            onChange={this.props.handleOptionChange}
            checked={this.props.value === 'ProductNum'}
          />
          <Translate value="prod_num" />
        </label>}
        <label className="col-xs-2" style={{width: isOLG ? '75px': isVAK ? '50px' : '70px', paddingRight: '0px'}}>
          <input
            style={{marginRight: '3px'}}
            type="radio"
            value="RefNum"
            onChange={this.props.handleOptionChange}
            checked={this.props.value === 'RefNum'}
          />
          <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />
        </label>
        <label className="col-xs-2" style={{width: '60px', paddingRight: '0px'}}>
          <input
            style={{marginRight: '3px'}}
            type="radio"
            value="Name"
            onChange={this.props.handleOptionChange}
            checked={this.props.value === 'Name'}
          />
          <Translate value="name" />
        </label>
        <label className="col-xs-2" style={{width: '60px', paddingRight: '0px'}}>
          <input
            style={{marginRight: '3px'}}
            type="radio"
            value="Description"
            onChange={this.props.handleOptionChange}
            checked={this.props.value === 'Description'}
          />
          <Translate value="desc" />
        </label>
        {isGFD &&
          <label className="col-xs-2" style={{width: '90px', paddingRight: '0px'}}>
            <input
              style={{marginRight: '3px'}}
              type="radio"
              value="Barcode"
              onChange={this.props.handleOptionChange}
              checked={this.props.value === 'Barcode'}
            />
          <Translate value="barcode" />
          </label>
        }
        {this.props.ezgoFlag && <label className="col-xs-2" style={{width: '75px', paddingRight: '0px'}}>
          <input
            style={{marginRight: '3px'}}
            type="radio"
            value="customer_id"
            onChange={this.props.handleOptionChange}
            checked={this.props.value === 'customer_id'}
          />
          <Translate value="cust_id" />
        </label>}
        {this.props.ezgoFlag && <label className="col-xs-2" style={{width: '75px', paddingRight: '0px'}}>
          <input
            style={{marginRight: '3px'}}
            type="radio"
            value="customer_name"
            onChange={this.props.handleOptionChange}
            checked={this.props.value === 'customer_name'}
          />
          <Translate value="cust_name_new" />
        </label>}
        {
          this.props.barcodeSearch && (
            <label className="col-xs-2" style={{width: '78px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="Barcode"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'Barcode'}
              />
              <Translate value="barcode" />
            </label>
          )
        }
        {
          this.props.loadingPortSearch && (
            <label className="col-xs-2" style={{width: '78px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="LoadingPort"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'LoadingPort'}
              />
              <Translate value="loading_port" />
            </label>
          )
        }
        {
          this.props.containerNum && (
            <label className="col-xs-3" style={{width: '112px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="container_num"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'container_num'}
              />
              <Translate value="container_num" />
            </label>
          )
        }
        {
          this.props.productNumSearch && (
            <label className="col-xs-3" style={{width: '72px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="PrNum"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'PrNum'}
              />
              <Translate value="pr_num" />
            </label>
          )
        }
        {
          this.props.mfgNumSearch && (
            <label className="col-xs-3" style={{width: '75px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="MfgNum"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'MfgNum'}
              />
              <Translate value="mfg_order" />
            </label>
          )
        }
        {
          this.props.cInvoiceSearch && (
            <label className="col-xs-3" style={{width: '100px', paddingRight: '0px'}}>
              <input
                style={{marginRight: '3px'}}
                type="radio"
                value="CommercialInvoice"
                onChange={this.props.handleOptionChange}
                checked={this.props.value === 'CommercialInvoice'}
              />
              <Translate value="c_invoice" />
            </label>
          )
        }
      </div>
    );
  },
});

export default TypeRadios;



// WEBPACK FOOTER //
// ./master/jsx/containers/Common/TypeRadios.jsx